import {mapState,mapMutations} from "vuex"
const searchMixin = {
  components:{

  },
  props:{
    
  },
  data(){
    return{
      value:''
    }
  },
  created(){
    
  },
  methods: {
    ...mapMutations('showData',['changeTFalse']),
    ...mapMutations('activeData',['changeValue']),
    //关闭
    close(){
      this.changeTFalse([{name:'searchShow',value:false}])
    },
    clear(){
      this.changeValue([{name:'searchVal',value:this.value}])
    },
    //跳转到投票页
    gotoUrl(url){
      if (this.$route.path == url) {
        return
      }
      this.$router.push({
        path:url,
        query:this.$route.query
      })
    },
    //保存search的值
    save(){
      this.changeValue([{name:'searchVal',value:this.value},{name:'tabarIndex',value:1}])
      this.changeTFalse([{name:'searchShow',value:false}])
      sessionStorage.setItem('tabarIndex',1)
      this.gotoUrl('/vote')
    },
    //接受到搜索内容去投票页搜索
    gotoVote(){
      this.save()
    }
  },
  watch:{

  },
  computed:{
    
  }
};
export default searchMixin;